<template>
  <v-card>
    <v-card-title class="grey lighten-3" scrollable>
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ title }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-sm pa-0 pt-3>
        <v-card class="pa-3 pb-0">
          <v-row>
            <v-col sm="3">
              <dates-range-picker
                :gtDateFromString="dateFrom"
                :gtDateToString="dateTo"
                :date-from-range-start="dateFromRangeStart"
                :date-to-range-end="dateToRangeEnd"
                :disabled="!priceId"
                @onRangeSelected="onDatesRangeSelected($event)"
                :outlined="outlinedInputs"
                hide-details
              ></dates-range-picker>
            </v-col>
            <v-col>
              <v-select
                :items="servicesList"
                v-model="serviceId"
                label="Service"
                item-text="name"
                item-value="id"
                :outlined="outlinedInputs"
                hide-details
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                label="Remarks"
                v-model="remarks"
                :outlined="outlinedInputs"
                hide-details=""
              ></v-text-field>
            </v-col>

            <v-col
              ><v-switch
                v-model="exception"
                label="Exception"
                class="ml-2"
                hide-details
              ></v-switch
            ></v-col>
            <v-col>
              <v-switch v-model="api" label="API" hide-details></v-switch
            ></v-col>
            <v-col
              ><v-switch
                v-if="$store.getters.hasAccessTo('third_party:marketplace')"
                v-model="marketPlace"
                label="Market Place"
                hide-details
              ></v-switch
            ></v-col>
          </v-row>
          <v-row>
            <v-col
              sm="2"
              v-if="
                $store.getters.hasAccessTo(
                  'administration_panel:business_models'
                )
              "
            >
              <business-model-list-select
                v-model="businessModel"
                :outlined="outlinedInputs"
                hide-details
              ></business-model-list-select>
            </v-col>
            <v-col
              sm="1"
              v-if="
                $store.getters.hasAccessTo(
                  'administration_panel:business_models'
                )
              "
            >
              <v-text-field
                label="Supplier Commission"
                v-model.number="supplierCommission"
                :outlined="outlinedInputs"
                hide-details=""
                :disabled="!bmUseCommission"
              ></v-text-field>
            </v-col>
            <v-col sm="1">
              <currency-list-select
                customLabel="Currency"
                :currency-code="currencyCode"
                v-model="currencyCode"
                :outlined="outlinedInputs"
                hide-details
                showCodeAsName
              ></currency-list-select>
            </v-col>
            <v-col>
              <rate-type-list-select
                @onSelect="onRateTypeChange"
                :outlined="outlinedInputs"
                hideNotInUse
                v-model="rateTypeCode"
                hide-not-in-use
              ></rate-type-list-select>
            </v-col>
            <v-col
              ><v-text-field
                label="Rate Plan"
                v-model="ratePlan"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field
            ></v-col>
            <v-col>
              <v-autocomplete
                :items="agentGroups"
                v-model="groupId"
                label="Agent Group"
                item-text="name"
                item-value="id"
                :outlined="outlinedInputs"
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col sm="1">
              <v-text-field
                label="Markup"
                v-model.number="markup"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                hide-details
                @change="onMarkupChange"
              ></v-text-field>
            </v-col>
            <v-col sm="1">
              <v-text-field
                label="Min Stay"
                v-model.number="minStay"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="1">
              <v-text-field
                label="Max Stay"
                v-model.number="maxStay"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="1">
              <v-text-field
                label="Min Pax"
                v-model.number="minPax"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="1">
              <v-text-field
                label="Max Pax"
                v-model.number="maxPax"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="pa-3 pb-0 mt-1">
          <v-row>
            <v-col sm="2">
              <v-text-field
                :label="isPPRate ? 'Adult Cost' : 'Cost'"
                v-model.number="adultBuy"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                @change="onMainPriceChange('adultSell')($event)"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="2">
              <v-text-field
                :label="isPPRate ? 'Adult Sell' : 'Sell'"
                v-model.number="adultSell"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                @change="updateDayPrices"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="2" v-show="isPPRate && !hideChildren">
              <v-text-field
                label="Child Cost"
                v-model.number="childBuy"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                @change="onMainPriceChange('childSell')($event)"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="2" v-show="isPPRate && !hideChildren">
              <v-text-field
                label="Child Sell"
                v-model.number="childSell"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                hide-details
                @change="updateDayPrices"
              ></v-text-field>
            </v-col>
            <v-col sm="2" v-show="isPPRate && !hideChildren">
              <v-text-field
                label="Infant Cost"
                v-model.number="infantBuy"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                @change="onMainPriceChange('infantSell')($event)"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col sm="2" v-show="isPPRate && !hideChildren">
              <v-text-field
                label="Infant Sell"
                v-model.number="infantSell"
                type="number"
                min="0"
                :outlined="outlinedInputs"
                @change="updateDayPrices"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-layout fluid>
          <v-flex xs12 pt-3>
            <v-card outlined>
              <v-data-table
                :headers="visibleHeaders"
                :items="daysPrices"
                item-key="day"
                hide-default-footer
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td class="text-xs-left">
                        <span>{{ dayOfWeek(item.day) }}</span>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          v-if="true"
                          v-model.number="$data['adultBuy' + item.day]"
                          @change="
                            onDayPriceChange('adultSell' + item.day)($event)
                          "
                          type="number"
                          min="0"
                        ></v-text-field>
                        <span v-else>{{ item.adultBuy }}</span>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          v-if="true"
                          v-model.number="$data['adultSell' + item.day]"
                          type="number"
                          min="0"
                        ></v-text-field>
                        <span v-else>{{ item.adultSell }}</span>
                      </td>

                      <td class="text-xs-left" v-if="isPPRate && !hideChildren">
                        <v-text-field
                          v-if="true"
                          v-model.number="$data['childBuy' + item.day]"
                          @change="
                            onDayPriceChange('childSell' + item.day)($event)
                          "
                          type="number"
                          min="0"
                        ></v-text-field>
                        <span v-else>{{ item.childBuy }}</span>
                      </td>
                      <td class="text-xs-left" v-if="isPPRate && !hideChildren">
                        <v-text-field
                          v-if="true"
                          v-model.number="$data['childSell' + item.day]"
                          type="number"
                          min="0"
                        ></v-text-field>
                        <span v-else>{{ item.childSell }}</span>
                      </td>

                      <td class="text-xs-left" v-if="isPPRate && !hideChildren">
                        <v-text-field
                          v-if="true"
                          v-model.number="$data['infantBuy' + item.day]"
                          @change="
                            onDayPriceChange('infantSell' + item.day)($event)
                          "
                          type="number"
                          min="0"
                        ></v-text-field>
                        <span v-else>{{ item.infantBuy }}</span>
                      </td>
                      <td class="text-xs-left" v-if="isPPRate && !hideChildren">
                        <v-text-field
                          v-if="true"
                          v-model.number="$data['infantSell' + item.day]"
                          type="number"
                          min="0"
                        ></v-text-field>
                        <span v-else>{{ item.infantSell }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <div v-if="debug">
      <code>{{ selectedRateType }}</code>
    </div>
    <v-card-actions class="grey lighten-4">
      <v-layout justify-end>
        <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
        <v-btn color="primary" @click="savePrice">Save</v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  SERVICE_PRICE_RECORD_QUERY,
  SERVICE_PRICE_UPDATE_MUTATION,
} from "../../../../../../constants/graphql";
import DatesRangePicker from "../../../../shared/DatesRangePicker";
import CurrencyListSelect from "../../../../shared/CurrencyListSelect";
import { PriceDetailsData } from "./PriceDetailsEditorDataMixin";
import { priceProperties } from "./price-properties";
import { removeGQLTypename } from "../../../../../../helpers";
import BusinessModelListSelect from "../../../../shared/BusinessModelListSelect";
import RateTypeListSelect from "../../../../shared/RateTypeListSelect.vue";
import gql from "graphql-tag";
const BUSINESS_MODEL_INFO = gql`
  query businesModelInfo($filter: BusinessModelFilterType) {
    businessModelInfo: businessModels(filter: $filter) {
      edges {
        node {
          id
          name
          code
          commission
        }
      }
    }
  }
`;
const moment = require("moment");

export default {
  name: "SupplierRatesEditPriceDetails",

  components: {
    DatesRangePicker,
    CurrencyListSelect,
    BusinessModelListSelect,
    RateTypeListSelect,
  },

  mixins: [PriceDetailsData],

  props: {
    priceId: {
      type: String,
      default: "",
    },
    rateTypes: {
      type: Array,
      default: () => [],
    },
    agentGroups: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {},
    },
    services: {
      type: Array,
      default: () => [],
    },
    hideChildren: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      adultBuy: 0,
      adultSell: 0,
      childBuy: 0,
      childSell: 0,
      infantBuy: 0,
      infantSell: 0,
      editableItem: 0,
      remarks: "",
      serviceId: "",
      selectedRateType: null,
      isPPRate: false,
    };
  },

  computed: {
    title() {
      const selectedService = this.services.find(
        (s) => s.node.id == this.serviceId
      );

      return selectedService && selectedService.node.code != ""
        ? `${selectedService.node.name}  (${selectedService.node.code})`
        : "Price Details";
    },
    visibleHeaders() {
      const headers = this.perPersonRates
        ? [...this.tableHeaders]
        : [...this.tablePIHeaders];
      return this.hideChildren
        ? headers.filter(
            (h) => !h.name.includes("child") && !h.name.includes("infant")
          )
        : headers;
    },
    perPersonRates() {
      this.isPPRate = this.selectedRateType && this.selectedRateType.includePax;
      return this.isPPRate;
    },
    servicesList() {
      return this.services && this.services.length > 0
        ? this.services.map(removeGQLTypename)
        : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    daysPrices() {
      let weekDaysPrices = [];

      for (let i = 1; i <= 7; i++) {
        weekDaysPrices.push({
          day: i,
          adultBuy: this["adultBuy" + i],
          adultSell: this["adultSell" + i],
          childBuy: this["childBuy" + i],
          childSell: this["childSell" + i],
          infantBuy: this["infantBuy" + i],
          infantSell: this["infantSell" + i],
        });
      }

      return weekDaysPrices;
    },
    dateFromRangeStart() {
      return moment().subtract(5, "years").toISOString(true);
    },
    dateToRangeEnd() {
      return moment().add(10, "years").toISOString(true);
    },
    bmUseCommission() {
      return (
        this.businessModelInfo &&
        this.businessModelInfo.edges &&
        this.businessModelInfo.edges.length > 0 &&
        this.businessModelInfo.edges[0].node.commission
      );
    },
  },

  methods: {
    onMarkupChange(newMarkup) {
      if (newMarkup && !isNaN(newMarkup)) {
        for (const priceType of ["item", "adult", "child", "infant"]) {
          this[`${priceType}Sell`] =
            Number(this[`${priceType}Buy`]) +
            Number(this[`${priceType}Buy`]) * (Number(newMarkup) / 100);
          for (let i = 1; i <= 7; i++) {
            this[`${priceType}Sell${i}`] =
              Number(this[`${priceType}Buy${i}`]) +
              Number(this[`${priceType}Buy${i}`]) * (Number(newMarkup) / 100);
          }
        }
      }
    },
    onRateTypeChange(selectedRateTypeCode) {
      this.selectedRateType = selectedRateTypeCode;
      this.ratePlan = selectedRateTypeCode.code;
      this.minPax = selectedRateTypeCode.minPax;
      this.maxPax = selectedRateTypeCode.maxPax;
      this.minStay = selectedRateTypeCode.minStay;
      this.maxStay = selectedRateTypeCode.maxStay;
    },
    onDayPriceChange(updateField) {
      return (cost) => {
        //if (this.markup > 0) {
        this[updateField] =
          Number(cost) + (Number(cost) * Number(this.markup)) / 100;
        // }
      };
    },
    onMainPriceChange(updateField) {
      return (cost) => {
        //if (this.markup > 0) {
        this[updateField] =
          Number(cost) + (Number(cost) * Number(this.markup)) / 100;
        //}
        this.updateDayPrices();
      };
    },
    updateDayPrices() {
      for (let i = 1; i <= 7; i++) {
        for (const paxType of ["adult", "child", "infant"]) {
          for (const priceType of ["Buy", "Sell"]) {
            this[`${paxType}${priceType}${i}`] = this[`${paxType}${priceType}`];
          }
        }
      }
    },
    closeDialog() {
      this.$emit("onCloseDialog");
    },
    dayOfWeek(number) {
      return moment().day(number).format("dddd");
    },
    savePrice() {
      const price = this.value ? { ...this.value } : {};
      for (let prop in priceProperties) {
        price[prop] = this[prop];
      }

      if (this.priceId) {
        this.$apollo
          .mutate({
            mutation: SERVICE_PRICE_UPDATE_MUTATION,
            variables: {
              serviceId: this.serviceId,
              ...price,
            },
          })
          .then((data) => {
            this.$emit("onSave");
          });
      } else {
        this.$emit("input", { ...price });
      }
    },
    onDatesRangeSelected(data) {
      this.dateTo = data.dateTo;
      this.dateFrom = data.dateFrom;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(data) {
        if (data) {
          for (let prop in priceProperties) {
            this[prop] = data[prop] ? data[prop] : priceProperties[prop];
          }
          ///set main price
          this.adultBuy = data.adultBuy1;
          this.adultSell = data.adultSell1;
          this.childBuy = data.childBuy1;
          this.childSell = data.childSell1;
          this.infantBuy = data.infantBuy1;
          this.infantSell = data.infantSell1;
        }
      },
    },
  },

  apollo: {
    servicePrice: {
      query: SERVICE_PRICE_RECORD_QUERY,
      variables() {
        return {
          id: this.priceId,
        };
      },
      skip() {
        return this.priceId ? false : true;
      },
      result({ data }) {
        for (let prop in priceProperties) {
          this[prop] = data.servicePrice[prop];
        }
        this.adultBuy = data.servicePrice.adultBuy1;
        this.adultSell = data.servicePrice.adultSell1;
        this.childBuy = data.servicePrice.childBuy1;
        this.childSell = data.servicePrice.childSell1;
        this.infantBuy = data.servicePrice.infantBuy1;
        this.infantSell = data.servicePrice.infantSell1;
        this.serviceId = data.servicePrice.service.id;
        //this.onRateTypeChange(this.rateTypeCode);
      },
    },
    businessModelInfo: {
      query: BUSINESS_MODEL_INFO,
      variables() {
        return { filter: { code_eq: this.businessModel } };
      },
    },
  },
};
</script>

<style scoped>
table.v-table tbody td {
  height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/edit/price-details/PriceDetailsEditor.vue